export default defineNuxtRouteMiddleware(async (to) => {
  devConsole.info("🛠️ Subscription middleware", to.fullPath);

  const { guardFeatureRoute } = useSubscriptionGuard();

  const canUseSubscriptionFeature = await guardFeatureRoute(to);

  if (!canUseSubscriptionFeature.ok) {
    return canUseSubscriptionFeature.result;
  }
});
